module.exports = __webpack_public_path__ + "static/img/qrcode.a4c935b3.png";